import { Component, Input, OnInit } from '@angular/core';
import { FiltersComponent } from 'src/app/common/filters.component';

@Component({
	selector: 'app-section-filter',
	templateUrl: './section-filter.component.html',
	styleUrls: ['./section-filter.component.scss'],
})
export class SectionFilterComponent extends FiltersComponent {
	@Input() kinds: Array<any>;
	filters = {
		kind: null,
		isActive: null,
	};
	filtersDefault() {
		this.filtersClear();
	}
}
